import React from "react";
import { Route } from "react-router-dom";
import {
  FormsCreate,
  FormsEdit,
  FormsMain,
  FormsView,
  IndexForms,
} from "../Views/Web/FormServ/Forms";
import {
  InsFormsCreate,
  InsFormsEdit,
  InsFormsMain,
  InsFormsView,
  InsIndexForms,
} from "../Views/Web/FormServ/InspectionForms";
import GeneratorForm from "../Views/Web/FormServ/InspectionForms/Generator";
import FireFrom from "../Views/Web/FormServ/InspectionForms/FireFrom";
import FireProtect from "../Views/Web/FormServ/InspectionForms/FireProtect";
import FormGenerator from "../Views/Web/FormServ/InspectionForms/FormGenerator";

function FormRoutes() {
  return (
    <Route path="forms" element={<FormsMain />}>
      <Route path="surveyforms" element={<FormsMain />}>
        <Route index element={<IndexForms />} />
        <Route path="create" element={<FormsCreate />} />
        <Route path="edit/:formsEditId" element={<FormsEdit />} />
        <Route path="view/:formsViewId" element={<FormsView />} />
      </Route>
      <Route path="insforms" element={<InsFormsMain />}>
        <Route index element={<InsIndexForms />} />
        <Route path="create" element={<InsFormsCreate />} />
        <Route path="edit/:formsEditId" element={<InsFormsEdit />} />
        <Route path="view/:formsViewId" element={<InsFormsView />} />
        <Route path="generator/view/:formsViewId" element={<GeneratorForm />} />
        <Route path="generatorForm/view/:formsViewId" element={<FormGenerator />} />

        <Route path="fire/view/:formsViewId" element={<FireFrom />} />
        <Route path="fireProtect/view/:formsViewId" element={<FireProtect />} />


      </Route>
    </Route>
  );
}

export default FormRoutes;
